import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { Tabs, Tab, TabList, TabPanel } from 'react-web-tabs';
import PropTypes from 'prop-types';
import styles from '../Report/Report.less';
import deliveryStyles from './Delivery.less';
import '../../theme/styles/react-web-tabs.css';
import i18next from 'i18next';
import PendingRequests from './PendingRequestTab';
import CompletedRequests from './CompletedRequestTab';
import { Button } from 'react-bootstrap';
import Modal from 'react-modal';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';
import { setDirection } from './../../utils/utils';
import PlaceRequest from './PlaceRequest';
import * as commonActions from '../../actions/commonActions';
import * as instrumentListActions from '../../actions/instrumentListActions';
import moment from 'moment';
import config from '../../config';

const refreshIcon = <MUIIconWithTooltip icon={'Refresh'} className={`${styles.clsIcon}`} title={i18next.t("refresh")} />
const closeIcon = <MUIIconWithTooltip icon={'Close'} className={`closeBtn commonCloseIcon`} title={i18next.t("close")}/>
const directionData = [
  { "classNames": "rptHeader", "elementType": "normal", "applyTo": "single", "tagNames": "label" },
  { "classNames": "tabsList", "elementType": "normal", "applyTo": "single", "tagNames": "div", "parent": "deliverySidebar" },
]



@connect(state => ({
  selectedCssColor: state.dashboardRoot.commonReducer.selectedCssColor,
  selectedLang:state.dashboardRoot.commonReducer.selectedLang,
  language:state.dashboardRoot.commonReducer.language,
  accBalMargBean: state.dashboardRoot.instrumentListReducer.accBalMargBean,
  deliveries: state.dashboardRoot.commonReducer.deliveries,
  marginForPD: state.dashboardRoot.commonReducer.marginForPD,
  showPlaceRequestSuccessModal: state.dashboardRoot.commonReducer.showPlaceRequestSuccessModal,
  placedRequestData: state.dashboardRoot.commonReducer.placedRequestData,
  userDetail: state.auth.userDetail,
  physicalDeliveryOrdCnfrmMsg: state.dashboardRoot.activityReducer.physicalDeliveryOrdCnfrmMsg,
}), {
  ...commonActions,
  ...instrumentListActions
})

export default class DeliveryComponent extends Component {

  static propTypes = {
    selectedCssColor: PropTypes.string,
    loadAccBalMargin: PropTypes.func.isRequired,
    getMarginForPD: PropTypes.func.isRequired,
    hidePlaceModal: PropTypes.func.isRequired,
    physicalDeliveryOrdCnfrmMsg: PropTypes.object,
    closePhysicalDeliveryOrdCnfrmMsg: PropTypes.func,
  };

  state = {
    tabId: 'pending',
    showPlaceRequest: false,
    fromDate: moment(new Date()).subtract(29,'d').format('DD-MM-YYYY'),
    toDate: moment(new Date()).format("DD-MM-YYYY"),
    openPositions: [],
    deliveries: [],
    physicalDeliveryCnfrmMsgFlag: false
  };

  componentDidMount() {
    const root = ReactDOM.findDOMNode(this);
    setDirection(root, directionData, this.props.selectedLang);

    // Call API for default tab (pending)
    this.props.loadDeliveries({ type: 'P' });

    // Open Positions
    this.props.getMarginForPD()

    this.setState({
      openPositions: this.props.marginForPD.map(item => ({
        cmdty: item.suf_desc,
        position: Number(item.fc_amt).toLocaleString(navigator.language, { minimumFractionDigits: config.QuantityRoundOff })
      }))
    });
  }

  handlePlaceRequestClick = () => {
    this.setState({ showPlaceRequest: true });
  };

  handleClosePlaceRequest = () => {
    this.setState({ showPlaceRequest: false });
  };

  handleCompletedDateChange = (startDate, endDate) => {
    this.setState({ fromDate: startDate, toDate: endDate });
    this.props.loadDeliveries({ type: 'C', from: startDate, to: endDate });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.selectedLang !== this.props.selectedLang) {
      const root = ReactDOM.findDOMNode(this);
      setDirection(root, directionData, this.props.selectedLang);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const root = ReactDOM.findDOMNode(this);
      setDirection(root, directionData, nextProps.selectedLang);
    }

    // Update Open Positions
    if (nextProps.marginForPD !== this.props.marginForPD) {
      this.setState({
        openPositions: nextProps.marginForPD.map(item => ({
          cmdty: item.suf_desc,
          position: Number(item.fc_amt).toLocaleString(navigator.language, { minimumFractionDigits: config.QuantityRoundOff })
        }))
      });
    }

    if (nextProps.deliveries !== this.props.deliveries) {
        console.log("deliveries",nextProps.deliveries);
      this.setState({ deliveries: nextProps.deliveries });
    }

    if (this.props.physicalDeliveryOrdCnfrmMsg.ID !== nextProps.physicalDeliveryOrdCnfrmMsg.ID) {
      this.setState({ physicalDeliveryCnfrmMsgFlag: true });
    }
  }

  changeTabs = (tabId) => {
    this.setState({ tabId });
    if (tabId === 'pending') {
      this.props.loadDeliveries({ type: 'P' });
    } else if (tabId === 'completed') {
      this.props.loadDeliveries({ type: 'C', from: this.state.fromDate, to: this.state.toDate });
    }
  };

  handleCloseSuccessModal = () => {
    this.props.hidePlaceModal();
  };

  //Close Physical Delivery Confirmation Modal
  closePhysicalDeliveryCnfrmModal = () => {
    try {
      this.setState({ physicalDeliveryCnfrmMsgFlag: false });
      this.props.closePhysicalDeliveryOrdCnfrmMsg();
    } catch (e) {
      this.props.logFileCreation({ error: e.message, originFunction: 'closePhysicalDeliveryCnfrmModal', component: "DashboardComponent" });
    }
  }

  render() {
    const { tabId, fromDate, toDate , openPositions} = this.state;
    const { language, showPlaceRequestSuccessModal, placedRequestData } = this.props;
    return (
      <div id="deliveryMainDiv" className={`${styles.container} ${deliveryStyles.deliveryContainer} ${this.props.selectedCssColor} ${language}`}>
        <div className={`${styles.reporthead} reportheader`}>
          <label className="rptHeader">{i18next.t('delivery')}</label>
        </div>
        <div>
          <Tabs defaultTab={tabId} onChange={this.changeTabs} id="rptTabs">
            <div className={`${deliveryStyles.deliverySidebar}`}>
              <TabList className="tabsList">
                <Tab
                  tabFor="pending"
                  id="deliveryTab1"
                  className="tabName active"
                  onClick={() => this.changeTabs('pending')}
                >
                  {i18next.t('pendingRequests')}
                </Tab>
                <Tab
                  tabFor="completed"
                  id="deliveryTab2"
                  className="tabName"
                  onClick={() => this.changeTabs('completed')}
                >
                  {i18next.t('completedRequests')}
                </Tab>
              </TabList>

              <Button className={deliveryStyles.placeRequest} onClick={this.handlePlaceRequestClick}>{i18next.t('placeRequest')}</Button>
            </div>

            <div>
              {tabId === 'pending' && (
                <TabPanel tabId="pending">
                  <PendingRequests
                    refreshIcon={refreshIcon}
                    closeIcon={closeIcon}
                    deliveryData={this.state.deliveries}
                  />
                </TabPanel>
              )}

              {tabId === 'completed' && (
                <TabPanel tabId="completed">
                  <CompletedRequests
                    refreshIcon={refreshIcon}
                    closeIcon={closeIcon}
                    onDateChange={this.handleCompletedDateChange}
                    startDate={fromDate}
                    endDate={toDate}
                    deliveryData={this.state.deliveries}
                  />
                </TabPanel>
              )}
            </div>
          </Tabs>
          {this.state.showPlaceRequest &&
            <PlaceRequest
              isOpen={this.state.showPlaceRequest}
              onClose={this.handleClosePlaceRequest}
              openPositionsData={openPositions}
            />}
        </div>

        <Modal isOpen={this.state.physicalDeliveryCnfrmMsgFlag} className={`${deliveryStyles.delModals} ${deliveryStyles.lmtCnfrmMsgModal}`} id="lmtModal" onAfterOpen={this.afterOpenModal}>
          <div ref="errorMSG" className="mdlWrap" >
            <div className={`${styles.header} header`}>
              {this.props.physicalDeliveryOrdCnfrmMsg.headerTitle != "" ? <span className={`${styles.msgTitle}`}> {i18next.t(this.props.physicalDeliveryOrdCnfrmMsg.headerTitle)}</span> : null}
                <span className={`${styles.closeImg} closeIcon commonCloseIcon`} onClick={this.closePhysicalDeliveryCnfrmModal}><MUIIconWithTooltip icon={'Close'} className="dp48 closeBtn" title={i18next.t("close")} /></span>
            </div>
            <div className={`${deliveryStyles.cnfrnMsgDiv} msg commonMsgDir`} id="confirmationMsgDiv">
              {this.props.physicalDeliveryOrdCnfrmMsg.remark1 != "" ?
                <p>{this.props.physicalDeliveryOrdCnfrmMsg.remark1}</p> : null}
              {this.props.physicalDeliveryOrdCnfrmMsg.remark2 != "" ?
                <p>{this.props.physicalDeliveryOrdCnfrmMsg.remark2}</p> : null}
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}